import React from 'react';
import ReactDOM from 'react-dom';
import './Modal.css';
import { Card, Icon } from 'tabler-react';

class Modal extends React.PureComponent {
  render() {
    const close = () => {
      toggleModal(false);
    };
    const { title = '提示', cancel = close, body } = this.props;
    return (
      <div className="malus-modal-backdrop">
        <Card className="malus-modal">
          <Card.Header>
            <Card.Title>{title}</Card.Title>
            <Card.Options>
              <Icon name="x" onClick={cancel} />
            </Card.Options>
          </Card.Header>
          <Card.Body>{body}</Card.Body>
        </Card>
      </div>
    );
  }
}

const toggleModal = isAppend => {
  const rootEl = document.getElementById('root');
  if (isAppend) {
    toggleModal(false);
    const modalEl = document.createElement('div');
    modalEl.id = 'modal';
    rootEl.appendChild(modalEl);
  } else {
    const modalEl = document.getElementById('modal');
    if (modalEl) {
      rootEl.removeChild(modalEl);
    }
  }
};

const modal = (body, rest) => {
  toggleModal(true);
  ReactDOM.render(
    <Modal body={body} {...rest} />,
    document.getElementById('modal'),
  );
};

export default modal;
